<template>
  <div>
    <table>
      <tr><th v-for="(header, idx) in headers" :key="'th-'+idx">{{ header }}</th></tr>
      <tr v-for="(item,idx) in list" :key="'tr-'+idx">
        <td>{{ item.created_time }}</td>
        <td><router-link style="text-decoration: underline"
          :to="`/office/admin/ship_agency/order_detail?id=${item.id}`">{{ item.reference_no }}</router-link></td>
        <td>{{ item.order_type_kor }}</td>
        <td>{{ item.status_kor }}</td>
      </tr>
    </table>
    <pagination ref="pagination" :total_page="total_page" @change="getData"></pagination>
  </div>
</template>

<script>
  import Pagination from "../../../module/common/Pagination";
  export default {
    name: "UserOrderList",
    components: {Pagination},
    created() {
      this.getData(1);
    },
    data() {
      return {
        headers: ['신청일자', '신청번호', '배송타입', '상태'],
        list: [],
        total_page: 1,
      }
    },
    methods: {
      getData(num) {
        this.$axios.get(`admin/shipagency/order?user_id=${this.$route.query.id}&page_num=${num}&page_length=10`).then(res => {
          this.list = res.data.data;
          this.total_page = res.data.total_page;
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  table
    width 100%
  table, th, td
    border 1px solid #dddddd

  th, td
    padding 8px 16px
    vertical-align middle

  th
    background-color #eeeeee
    width 140px
</style>
